module.exports = __webpack_public_path__ + "img/logo1.fed07277.png";